import { Card as FluentCard, CardHeader, CardPreview } from '@fluentui/react-components';
import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className }: CardProps) {
  return (
    <FluentCard className={className} style={{ padding: 'var(--spacing-md)' }}>
      {children}
    </FluentCard>
  );
}

export { CardHeader, CardPreview };
